export enum SubjectGenders {
    All = "A",
    Male = "M",
    Male_and_Non_Binary = "MNB",
    Female = "F",
    Female_and_Non_Binary = "FNB",
    Non_Binary = "NB",
    Both = "B",
}